import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; //useSearchParams,
import Layout from '../../Global/Layout';
import DataTable from '../../Global/DataTable';
import { showSuccess, showError, showConfirm } from '../../../utils/sweetAlertConfig';
import { LottoBallsDisplay } from '../../../utils/LottoBalls';
import { extractTimeFromTimestamp, dateStampToDateDB, parseDatetimeLocal, API_CONFIG, LOTTO_TYPE, LOTTO_BALL_TYPE, MSG_REMARK, CUSTOMER_TIER_DISPLAY } from '../../../contexts/constants';
import DatePicker, { registerLocale } from 'react-datepicker';
import { th } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('th', th);

const ManagePrizesNewMega = ({ onLogout, userRole }) => {
  // const [searchParams, setSearchParams] = useSearchParams();
  // const type = searchParams.get('type');
  const lottoType = 'megamillions';
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode } = location.state || {}; // data for edit, mode: 'view' | 'edit'

  const [drawDate, setDrawDate] = useState('');
  const [drawTime, setDrawTime] = useState('');
  const [openDate, setOpenDate] = useState('');
  const [openTime, setOpenTime] = useState('');
  const [closeDate, setCloseDate] = useState('');
  const [closeTime, setCloseTime] = useState('');
  const [status, setStatus] = useState(false);
  const [summaryStatus, setSummaryStatus] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState('');
  const [originalWinBall, setOriginalWinBall] = useState(null);
  const [originalWinBallSpecial, setOriginalWinBallSpecial] = useState(null);
  const [purchase, setPurchase] = useState('190');
  const [purchase_normal, setPurchaseNormal] = useState('190');
  const [purchase_silver, setPurchaseSilver] = useState('187');
  const [purchase_gold, setPurchaseGold] = useState('185');

	const [prizes, setPrizes] = useState({
		match5PlusPowerball: '',
		match5: '',
		match4PlusPowerball: '',
		match4: '',
		match3PlusPowerball: '',
		match3: '',
		match2PlusPowerball: '',
		match1PlusPowerball: '',
		match0PlusPowerball: ''
	});

  	const [prizesDollar, setPrizesDollar] = useState({
		match5PlusPowerball: '',
		match5: '',
		match4PlusPowerball: '',
		match4: '',
		match3PlusPowerball: '',
		match3: '',
		match2PlusPowerball: '',
		match1PlusPowerball: '',
		match0PlusPowerball: ''
	});


  // Load latest prizes for new entries
  useEffect(() => {
    const loadLatestData = async () => {
      // Only load when creating new entry (not edit or view mode)
      if (data) return;

	  try {
		const response = await fetch(`${API_CONFIG.BASE_URL}/awards?type=megamillions&limit=1`, {
		  headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
		});

		if (response.ok) {
			const result = await response.json();
			if (result.data && result.data.length > 0) {
				const latestAward = result.data[0];
				// Set prices from latest award
				if (latestAward.salePrices?.default) setPurchase(latestAward.salePrices.default);
				if (latestAward.salePrices?.normal) setPurchaseNormal(latestAward.salePrices.normal);
				if (latestAward.salePrices?.silver) setPurchaseSilver(latestAward.salePrices.silver);
				if (latestAward.salePrices?.gold) setPurchaseGold(latestAward.salePrices.gold);
				// Set prizes from latest award
				if (latestAward.prizes) {
				  setPrizes({
					match5PlusPowerball: latestAward.prizes.match_5_1?.bath?.toLocaleString() || '',
					match5: latestAward.prizes.match_5_0?.bath?.toLocaleString() || '',
					match4PlusPowerball: latestAward.prizes.match_4_1?.bath?.toLocaleString() || '',
					match4: latestAward.prizes.match_4_0?.bath?.toLocaleString() || '',
					match3PlusPowerball: latestAward.prizes.match_3_1?.bath?.toLocaleString() || '',
					match3: latestAward.prizes.match_3_0?.bath?.toLocaleString() || '',
					match2PlusPowerball: latestAward.prizes.match_2_1?.bath?.toLocaleString() || '',
					match1PlusPowerball: latestAward.prizes.match_1_1?.bath?.toLocaleString() || '',
					match0PlusPowerball: latestAward.prizes.match_0_1?.bath?.toLocaleString() || ''
				  });

				  setPrizesDollar({
					match5PlusPowerball: latestAward.prizes.match_5_1?.dollar?.toLocaleString() || '',
					match5: latestAward.prizes.match_5_0?.dollar?.toLocaleString() || '',
					match4PlusPowerball: latestAward.prizes.match_4_1?.dollar?.toLocaleString() || '',
					match4: latestAward.prizes.match_4_0?.dollar?.toLocaleString() || '',
					match3PlusPowerball: latestAward.prizes.match_3_1?.dollar?.toLocaleString() || '',
					match3: latestAward.prizes.match_3_0?.dollar?.toLocaleString() || '',
					match2PlusPowerball: latestAward.prizes.match_2_1?.dollar?.toLocaleString() || '',
					match1PlusPowerball: latestAward.prizes.match_1_1?.dollar?.toLocaleString() || '',
					match0PlusPowerball: latestAward.prizes.match_0_1?.dollar?.toLocaleString() || ''
				  });
				}
			}
		}
	  } catch (error) {
		console.error('Error loading latest data:', error);
	  }
    };

    loadLatestData();
  }, [data]);

  // Load data if editing
  useEffect(() => {
    const loadAwardData = async () => {
      if (data && data.id) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${API_CONFIG.BASE_URL}/awards/${data.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (!response.ok) {
            throw new Error('Failed to fetch award data');
          }

          const awardData = await response.json();

          // Format date and time from timestamp
          const drawDateTime = parseDatetimeLocal(awardData.drawDate);
          const openDateTime = awardData.orderAcceptanceDate ? parseDatetimeLocal(awardData.orderAcceptanceDate) : null;
          const closeDateTime = awardData.orderClosingDate ? parseDatetimeLocal(awardData.orderClosingDate) : null;

          setDrawDate(dateStampToDateDB(drawDateTime));
          setDrawTime(extractTimeFromTimestamp(awardData.drawDate));

          if (openDateTime) {
            setOpenDate(dateStampToDateDB(openDateTime));
            setOpenTime(extractTimeFromTimestamp(awardData.orderAcceptanceDate));
          }

          if (closeDateTime) {
            setCloseDate(dateStampToDateDB(closeDateTime));
            setCloseTime(extractTimeFromTimestamp(awardData.orderClosingDate));
          }

          setYoutubeUrl(awardData.youtubeLink || '');
          setStatus(awardData.status || false);
          setSummaryStatus(awardData.summaryStatus || false);
          setOriginalWinBall(awardData.winningNumbers || null);
          setOriginalWinBallSpecial(awardData.powerBall || null);
          setPurchase(awardData.salePrices?.default || '20');
          setPurchaseNormal(awardData.salePrices?.normal || '20');
          setPurchaseSilver(awardData.salePrices?.silver || '18');
          setPurchaseGold(awardData.salePrices?.gold || '15');

          // Load prizes
          if (awardData.prizes) {
            setPrizes({
              match5PlusPowerball: awardData.prizes.match_5_1?.bath?.toLocaleString() || '',
              match5: awardData.prizes.match_5_0?.bath?.toLocaleString() || '',
              match4PlusPowerball: awardData.prizes.match_4_1?.bath?.toLocaleString() || '',
              match4: awardData.prizes.match_4_0?.bath?.toLocaleString() || '',
              match3PlusPowerball: awardData.prizes.match_3_1?.bath?.toLocaleString() || '',
              match3: awardData.prizes.match_3_0?.bath?.toLocaleString() || '',
              match2PlusPowerball: awardData.prizes.match_2_1?.bath?.toLocaleString() || '',
              match1PlusPowerball: awardData.prizes.match_1_1?.bath?.toLocaleString() || '',
              match0PlusPowerball: awardData.prizes.match_0_1?.bath?.toLocaleString() || ''
            });

            setPrizesDollar({
              match5PlusPowerball: awardData.prizes.match_5_1?.dollar?.toLocaleString() || '',
              match5: awardData.prizes.match_5_0?.dollar?.toLocaleString() || '',
              match4PlusPowerball: awardData.prizes.match_4_1?.dollar?.toLocaleString() || '',
              match4: awardData.prizes.match_4_0?.dollar?.toLocaleString() || '',
              match3PlusPowerball: awardData.prizes.match_3_1?.dollar?.toLocaleString() || '',
              match3: awardData.prizes.match_3_0?.dollar?.toLocaleString() || '',
              match2PlusPowerball: awardData.prizes.match_2_1?.dollar?.toLocaleString() || '',
              match1PlusPowerball: awardData.prizes.match_1_1?.dollar?.toLocaleString() || '',
              match0PlusPowerball: awardData.prizes.match_0_1?.dollar?.toLocaleString() || ''
            });
          }
        } catch (error) {
          console.error('Error loading award data:', error);
          showError('เกิดข้อผิดพลาด', 'ไม่สามารถโหลดข้อมูลผลรางวัลได้');
        }
      } else if (data) {
        // Load from passed data (old format)
        setDrawDate(data.drawDate || '');
        setDrawTime(data.drawTime || '');
        setOpenDate(data.openDate || '');
        setOpenTime(data.openTime || '');
        setCloseDate(data.closeDate || '');
        setCloseTime(data.closeTime || '');
        setYoutubeUrl(data.youtubeUrl || '');
        setStatus(data.status || false);
        setPurchase(data.purchase || '');
      }
    };

    loadAwardData();
  }, [data, mode]);

  	if (!['sysadmin', 'owner', 'admin'].includes(userRole)) {
		window.location.href = '/forbidden';
		return null;
	}

  const isViewMode = mode === 'view';
  const isEditMode = mode === 'edit';
  const pageTitle = isViewMode ? 'ดูรายละเอียดราตาง' : isEditMode ? 'แก้ไขตาราง' : 'เพิ่มตาราง';

  const formatNumberWithCommas = (value) => {
    const numericValue = value.replace(/\D/g, '');
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handlePrizeChange = (key, value) => {
    const formatted = formatNumberWithCommas(value);
    setPrizes({ ...prizes, [key]: formatted });
  };

  const handlePrizeDollarChange = (key, value) => {
    const formatted = formatNumberWithCommas(value);
    setPrizesDollar({ ...prizesDollar, [key]: formatted });
  };

  const handleSubmit = async (e, skip_confirm = false) => {
    e.preventDefault();

    // Check if already summarized and user is not owner
    if (isEditMode && summaryStatus/* && userRole !== 'owner'*/) {
      await showError('ไม่สามารถดำเนินการได้', 'ผลรางวัลนี้ถูกสรุปแล้ว ไม่สามารถแก้ไขได้');
      return;
    }

    if (!drawDate || !drawTime) {
      showError('ข้อมูลไม่ครบ', 'กรุณากรอกวันที่และเวลาที่ออกรางวัล');
      return;
    }

    // Helper function to remove commas and convert to number
    const parseNumber = (value) => {
      if (!value) return null;
      return parseFloat(String(value).replace(/,/g, ''));
    };

    // Prepare data for API
    const prizeAnnouncementDate = `${drawDate} ${drawTime}:00`;
    const orderAcceptanceDate = openDate && openTime ? `${openDate} ${openTime}:00` : null;
    const orderClosingDate = closeDate && closeTime ? `${closeDate} ${closeTime}:00` : null;

    const submitData = {
      lotType: 'megamillions',
      prizeAnnouncementDate,
      orderAcceptanceDate,
      orderClosingDate,
      orderActive: status,
    //   summaryStatus: summaryStatus,
      summaryStatus: skip_confirm,
      youtubeLink: youtubeUrl,
      ...(isEditMode && { winBall: originalWinBall, winBallSpecial: originalWinBallSpecial }),
      salePrice: parseNumber(purchase),
      salePriceNormal: parseNumber(purchase_normal),
      salePriceSilver: parseNumber(purchase_silver),
      salePriceGold: parseNumber(purchase_gold),
      prizes: {
        match_5_1: {
          bath: parseNumber(prizes.match5PlusPowerball),
          dollar: parseNumber(prizesDollar.match5PlusPowerball)
        },
        match_5_0: {
          bath: parseNumber(prizes.match5),
          dollar: parseNumber(prizesDollar.match5)
        },
        match_4_1: {
          bath: parseNumber(prizes.match4PlusPowerball),
          dollar: parseNumber(prizesDollar.match4PlusPowerball)
        },
        match_4_0: {
          bath: parseNumber(prizes.match4),
          dollar: parseNumber(prizesDollar.match4)
        },
        match_3_1: {
          bath: parseNumber(prizes.match3PlusPowerball),
          dollar: parseNumber(prizesDollar.match3PlusPowerball)
        },
        match_3_0: {
          bath: parseNumber(prizes.match3),
          dollar: parseNumber(prizesDollar.match3)
        },
        match_2_1: {
          bath: parseNumber(prizes.match2PlusPowerball),
          dollar: parseNumber(prizesDollar.match2PlusPowerball)
        },
        match_1_1: {
          bath: parseNumber(prizes.match1PlusPowerball),
          dollar: parseNumber(prizesDollar.match1PlusPowerball)
        },
        match_0_1: {
          bath: parseNumber(prizes.match0PlusPowerball),
          dollar: parseNumber(prizesDollar.match0PlusPowerball)
        }
      }
    };

	if(skip_confirm !== true) {
		const confirmTitle = mode === 'edit' ? 'บันทึกการแก้ไข?' : 'เพิ่มข้อมูลใหม่?';
		const confirmText = mode === 'edit'
		? 'คุณต้องการบันทึกการแก้ไขใช่หรือไม่?'
		: 'คุณต้องการบันทึกการเพิ่มใช่หรือไม่?';

		const result = await showConfirm({
			title: confirmTitle,
			text: confirmText,
			confirmText: 'ตกลง',
			cancelText: 'ยกเลิก',
			confirmVariant: mode === 'edit' ? 'primary' : 'success',
			reverseButtons: true
		});

		if (!result.isConfirmed) return;
	}

    try {
      const token = localStorage.getItem('token');
      const url = isEditMode
        ? `${API_CONFIG.BASE_URL}/awards/${data.id}`
        : `${API_CONFIG.BASE_URL}/awards`;
      const method = isEditMode ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(submitData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to save award result');
      }

      const successMessage = isEditMode ? 'แก้ไขผลรางวัลเรียบร้อยแล้ว' : 'บันทึกผลรางวัลเรียบร้อยแล้ว';
      showSuccess('บันทึกสำเร็จ', successMessage);

      // Navigate back to history
      navigate('/manage_data/prizes-history');
    } catch (error) {
      console.error('Error saving award result:', error);
      showError('เกิดข้อผิดพลาด', error.message || 'ไม่สามารถบันทึกผลรางวัลได้');
	  if(skip_confirm === true){
		setSummaryStatus(false);
	  }
    }
  };

  const resetForm = () => {
    navigate('/manage_data/prizes-history');
  };

  const prizeLabels = {
    match5PlusPowerball: { label: 'Match 5 + '+LOTTO_BALL_TYPE[lottoType]+' (แจ็กพอต)', whiteBalls: 5, hasRedBall: true },
    match5: { label: 'Match 5', whiteBalls: 5, hasRedBall: false },
    match4PlusPowerball: { label: 'Match 4 + '+LOTTO_BALL_TYPE[lottoType], whiteBalls: 4, hasRedBall: true },
    match4: { label: 'Match 4', whiteBalls: 4, hasRedBall: false },
    match3PlusPowerball: { label: 'Match 3 + '+LOTTO_BALL_TYPE[lottoType], whiteBalls: 3, hasRedBall: true },
    match3: { label: 'Match 3', whiteBalls: 3, hasRedBall: false },
    match2PlusPowerball: { label: 'Match 2 + '+LOTTO_BALL_TYPE[lottoType], whiteBalls: 2, hasRedBall: true },
    match1PlusPowerball: { label: 'Match 1 + '+LOTTO_BALL_TYPE[lottoType], whiteBalls: 1, hasRedBall: true },
    match0PlusPowerball: { label: 'Match 0 + '+LOTTO_BALL_TYPE[lottoType], whiteBalls: 0, hasRedBall: true }
  };

  const prizeTableData = Object.keys(prizeLabels).map((key) => ({
    id: key,
    key: key,
    ...prizeLabels[key]
  }));

  const prizeColumns = [
    {
      	key: 'match',
      	header: 'ลักษณะรางวัล Match',
		render: (row) => {
			let _ballSet = [];
			for (let index = 0; index < row.whiteBalls; index++) {
				_ballSet.push('');
			}
			return <LottoBallsDisplay grayBalls={_ballSet} specialBall={row.hasRedBall} type="megamillions" wh={10} />
		}
    },
    {
      key: 'description',
      header: 'คำอธิบาย',
      render: (row) => (
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {row.label}
        </span>
      )
    },
    {
      key: 'amount',
      header: 'จำนวนเงิน (บาท)',
      width: '30%',
      render: (row) => (
        <input
          type="text"
          value={prizes[row.key]}
          onChange={(e) => handlePrizeChange(row.key, e.target.value)}
          placeholder="เช่น 1,000,000"
          disabled={isViewMode}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
        />
      )
    },
    {
      key: 'amount_dollar',
      header: 'จำนวนเงิน (Dollar)',
      width: '30%',
      render: (row) => (
        <input
          type="text"
          value={prizesDollar[row.key]}
          onChange={(e) => handlePrizeDollarChange(row.key, e.target.value)}
          placeholder="เช่น 1,000,000"
          disabled={isViewMode}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-right font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
        />
      )
    }
  ];

  return (
    <Layout title={pageTitle+` `+LOTTO_TYPE[lottoType]} onLogout={onLogout} userRole={userRole}>
      <div className="max-w-6xl mx-auto">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Date and Time */}
          <div className="bg-white dark:bg-surface-dark border border-borderc-light dark:border-borderc-dark rounded-xl shadow-card dark:shadow-carddark p-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">ข้อมูลพื้นฐาน</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  วันที่ออกรางวัล <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={drawDate ? parseDatetimeLocal(drawDate) : null}
                  onChange={(date) => setDrawDate(date ? dateStampToDateDB(date) : '')}
                  disabled={isViewMode}
                  locale="th"
                  dateFormat="dd/MM/yyyy"
				  placeholderText='วัน/เดือน/ปี'
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                  wrapperClassName="w-full"
				  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  เวลาที่ออกรางวัล <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={drawTime ? new Date(`2000-01-01T${drawTime}:00`) : null}
                  onChange={(time) => {
                    if (time) {
                      const hours = time.getHours().toString().padStart(2, '0');
                      const minutes = time.getMinutes().toString().padStart(2, '0');
                      setDrawTime(`${hours}:${minutes}`);
                    } else {
                      setDrawTime('');
                    }
                  }}
                  disabled={isViewMode}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="เวลา"
                  dateFormat="HH:mm"
                  timeFormat="HH:mm"
				  placeholderText='ชั่วโมง:นาที'
                  locale="th"
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  วันที่เปิดรับคำสั่งซื้อ <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={openDate ? parseDatetimeLocal(openDate) : null}
                  onChange={(date) => setOpenDate(date ? dateStampToDateDB(date) : '')}
                  disabled={isViewMode}
                  locale="th"
                  dateFormat="dd/MM/yyyy"
				  placeholderText='วัน/เดือน/ปี'
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                  wrapperClassName="w-full"
				  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  เวลาที่เปิดรับคำสั่งซื้อ <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={openTime ? new Date(`2000-01-01T${openTime}:00`) : null}
                  onChange={(time) => {
                    if (time) {
                      const hours = time.getHours().toString().padStart(2, '0');
                      const minutes = time.getMinutes().toString().padStart(2, '0');
                      setOpenTime(`${hours}:${minutes}`);
                    } else {
                      setOpenTime('');
                    }
                  }}
                  disabled={isViewMode}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="เวลา"
                  dateFormat="HH:mm"
                  timeFormat="HH:mm"
				  placeholderText='ชั่วโมง:นาที'
                  locale="th"
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  วันที่ปิดรับคำสั่งซื้อ <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={closeDate ? parseDatetimeLocal(closeDate) : null}
                  onChange={(date) => setCloseDate(date ? dateStampToDateDB(date) : '')}
                  disabled={isViewMode}
                  locale="th"
                  dateFormat="dd/MM/yyyy"
				  placeholderText='วัน/เดือน/ปี'
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                  wrapperClassName="w-full"
				  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  เวลาที่ปิดรับคำสั่งซื้อ <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selected={closeTime ? new Date(`2000-01-01T${closeTime}:00`) : null}
                  onChange={(time) => {
                    if (time) {
                      const hours = time.getHours().toString().padStart(2, '0');
                      const minutes = time.getMinutes().toString().padStart(2, '0');
                      setCloseTime(`${hours}:${minutes}`);
                    } else {
                      setCloseTime('');
                    }
                  }}
                  disabled={isViewMode}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="เวลา"
                  dateFormat="HH:mm"
                  timeFormat="HH:mm"
				  placeholderText='ชั่วโมง:นาที'
                  locale="th"
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                  required
                />
              </div>
              {/* Youtube */}
              <div className="">
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  ลิงก์ YouTube
                </label>
                <input
                  type="url"
                  value={youtubeUrl}
                  onChange={(e) => setYoutubeUrl(e.target.value)}
                  disabled={isViewMode}
                  placeholder="https://www.youtube.com/watch?v=..."
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                />
              </div>
              {/* Switch off date */}
              <div className="">
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  สถานะ เปิด/ปิด รับคำสั่งซื้อ
                </label>
                <div className="flex justify-start py-2">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={status}
					  disabled={isViewMode}
                      onChange={() => setStatus(!status)}
                      className="sr-only peer"
                    />
                    <div className={`w-11 h-6 ${status ? 'bg-gray-300 dark:bg-gray-600' : 'bg-red-300 dark:bg-red-800'} peer-focus:outline-none peer-focus:ring-2 ${status ? 'peer-focus:ring-green-500' : 'peer-focus:ring-red-500'} rounded-full peer ${status ? 'peer-checked:bg-green-600' : 'peer-checked:bg-red-600'} peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-red-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all`}></div>
                    <span className={`ml-2 text-sm ${status ? 'text-green-700 dark:text-green-400' : 'text-red-700 dark:text-red-400'} font-medium`}>
                      {status ? 'เปิด' : 'ปิด'}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Purchase Price */}
          <div className="bg-white dark:bg-surface-dark border border-borderc-light dark:border-borderc-dark rounded-xl shadow-card dark:shadow-carddark p-6">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">กำหนดราคาซื้อ/ใบ</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">กำหนดราคาซื้อ/ใบ (บาท) <span className="text-red-500">*</span></label>
                <input type="text" value={purchase} onChange={(e) => setPurchase(e.target.value)} disabled={isViewMode} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">ราคา ลูกค้าระดับ {CUSTOMER_TIER_DISPLAY.normal} (บาท) <span className="text-red-500">*</span></label>
                <input type="text" value={purchase_normal} onChange={(e) => setPurchaseNormal(e.target.value)} disabled={isViewMode} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">ราคา ลูกค้าระดับ {CUSTOMER_TIER_DISPLAY.silver} (บาท) <span className="text-red-500">*</span></label>
                <input type="text" value={purchase_silver} onChange={(e) => setPurchaseSilver(e.target.value)} disabled={isViewMode} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">ราคา ลูกค้าระดับ {CUSTOMER_TIER_DISPLAY.gold} (บาท) <span className="text-red-500">*</span></label>
                <input type="text" value={purchase_gold} onChange={(e) => setPurchaseGold(e.target.value)} disabled={isViewMode} required className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed" />
              </div>
            </div>
          </div>

          {/* Prize Amounts */}
		  <div className="bg-white dark:bg-surface-dark border border-borderc-light dark:border-borderc-dark rounded-xl shadow-card dark:shadow-carddark p-6">
			<h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">กำหนดรางวัล {LOTTO_TYPE[lottoType]}</h2>
			<p className="text-sm text-gray-600 dark:text-gray-400 mb-4">{MSG_REMARK.PRIZE_EXCHANGE_RATE}</p>
			<DataTable
			columns={prizeColumns}
			data={prizeTableData}
			loading={false}
			page={1}
			pageSize={prizeTableData.length}
			totalItems={prizeTableData.length}
			onPageChange={() => {}}
			onPageSizeChange={() => {}}
			showPagination={false}
			emptyMessage="ไม่มีข้อมูลรางวัล"
			/>
		  </div>

          {/* Submit Buttons */}
          {!isViewMode && (
            <div className="flex justify-end gap-4">
              <button
                type="button"
                onClick={resetForm}
                className="px-6 py-2 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-white rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500 transition"
              >
                ยกเลิก
              </button>
              <button
                type="submit"
                className={`px-6 py-2 rounded-lg transition ${
                  isEditMode && summaryStatus/* && userRole !== 'owner'*/
                    ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700 text-white'
                }`}
                disabled={isEditMode && summaryStatus/* && userRole !== 'owner'*/}
              >
                บันทึก
              </button>
            </div>
          )}

          {isViewMode && (
            <div className="flex justify-end">
              <button
                type="button"
                onClick={resetForm}
                className="px-6 py-2 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-white rounded-lg hover:bg-gray-400 dark:hover:bg-gray-500 transition"
              >
                ปิด
              </button>
            </div>
          )}
        </form>
      </div>

    </Layout>
  );
};

export default ManagePrizesNewMega;
